import { useEffect, useState } from 'react';
import Layout from '../../components/common/pageLayout'
import './ncr.css'
import { v3_ncr_projects } from '../../actions/v3/ncr';
import constant from '../../constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import Filter from '../../components/NCR/IndexList/filter';
import List from '../../components/NCR/IndexList/index';
import { encodeBase64JsonPayload, replacePageState } from '../../utils';

const Index = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [keyword, setKeyword] = useState('');
    const [groupBy, setGroupBy] = useState('none');
    const [filterPayload, setFilterPayload] = useState({});

    const encodedFilterPayload = encodeBase64JsonPayload(filterPayload);

    useEffect(() => {
        v3_ncr_projects(currentPage, limit, keyword, groupBy, encodedFilterPayload).then((res) => {
            if (res.status) {
                console.log(JSON.stringify(res.result))
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.ncrIndex.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])

    useEffect(() => {
        setCurrentPage(1)
        v3_ncr_projects(1, limit, keyword, groupBy, encodedFilterPayload).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.ncrIndex.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [keyword, groupBy, encodedFilterPayload])
    return (
        <Layout title='NCR'>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body1">
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="appraisal-report-table-responsive">
                                        <Filter
                                            keyword={keyword}
                                            setKeyword={setKeyword}
                                            groupBy={groupBy}
                                            setGroupBy={setGroupBy}
                                            initialFilter={filterPayload}
                                            onChangeFilter={setFilterPayload}
                                        />

                                        {data && <List
                                            data={data}
                                            limit={limit}
                                            handlePageChange={(newPage) => setCurrentPage(newPage)}
                                        />}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </Layout>
    )
}

export default Index